import React, { useState } from "react";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { Dayjs } from "dayjs";
import { SxProps, Theme } from "@mui/material";

interface EditableTimeLabelProps {
    value: Dayjs | null;
    onChange: (newValue: Dayjs | null) => void;
    disabled?: boolean;
    format?: string;
    sx?: SxProps<Theme>;
}

const EditableTimeLabel: React.FC<EditableTimeLabelProps> = ({
                                                                 value,
                                                                 onChange,
                                                                 disabled = false,
                                                                 format = "mm:ss",
                                                                 sx
                                                             }) => {
    // Stati per tracciare se il mouse è sopra il componente o se ci abbiamo cliccato dentro
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    // Vogliamo mostrare l'underline nativo di MUI se il campo è in focus OPPURE in hover
    const showUnderline = isHovered || isFocused;

    return (
        <TimeField
            value={value}
            onChange={onChange}
            disabled={disabled}
            format={format}
            slotProps={{
                textField: {
                    variant: 'standard',
                    // Agganciamo gli eventi per aggiornare gli stati
                    onMouseEnter: () => !disabled && setIsHovered(true),
                    onMouseLeave: () => !disabled && setIsHovered(false),
                    onFocus: () => !disabled && setIsFocused(true),
                    onBlur: () => !disabled && setIsFocused(false),

                    InputProps: {
                        // Pilotiamo l'underline nativo tramite l'inverso del nostro controllo logico
                        disableUnderline: !showUnderline,
                    },

                    sx: {
                        ...sx,
                        // Il CSS ora è pulitissimo: serve solo a gestire il comportamento del testo e del mouse
                        "& input": {
                            cursor: disabled ? "default" : "pointer",
                            textAlign: "center",
                            paddingBottom: "4px",
                        },
                        "& .Mui-focused input": {
                            cursor: "text",
                        }
                    }
                }
            }}
        />
    );
};

export default EditableTimeLabel;